export default class Driver {
  id: string;
  firstName: string;
  lastName: string;
  headshotUrl: string;
  value: number;
  raceDriverId: number;
  finishPoints: number;
  racePoints: number;
  totalPoints: number;

  constructor(starter?: any) {
    starter = starter || {};
    // Deal with 0 Id's
    this.id = starter.id !== null && !isNaN(starter.id) ? starter.id : null;
    this.firstName = starter.firstName || null;
    this.lastName = starter.lastName || null;
    this.headshotUrl = starter.headshotUrl || null;
    this.value = starter.value || 0;
    this.raceDriverId = starter.raceDriverId || null;
    this.finishPoints = starter.finishPoints || 0;
    this.racePoints = starter.racePoints || 0;
    this.totalPoints = starter.totalPoints || 0;
  }

  getAvatar() {
    if (this.headshotUrl) {
      return this.headshotUrl;
    } else {
      return `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYGKoBwAAjwCDPIVtWQAAAABJRU5ErkJggg==`;
    }
  }
}
